import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    scaling: {
        id: "tasks.rhythmSorting.scaling",
    },
    editCards: {
        id: "tasks.rhythmSorting.editCards",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    following: {
        id: "tasks.rhythmSorting.following",
    },
    beatDivision: {
        id: "tasks.rhytmSorting.beatDivision",
    },
    even: {
        id: "tasks.rhytmSorting.beatDivision.even",
    },
    odd: {
        id: "tasks.rhytmSorting.beatDivision.odd",
    },
    variable: {
        id: "tasks.rhytmSorting.beatDivision.variable",
    },
    scaleAlert: {
        id: "tasks.scaleAlert",
    },
});

export default messages;
